"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hourCycles = void 0;
/* @generated */
// prettier-ignore
exports.hourCycles = {
  "001": ["h23", "h12"],
  "AC": ["h23", "h12"],
  "AD": ["h23"],
  "AE": ["h12", "h23"],
  "AF": ["h23", "h12"],
  "AG": ["h12", "h23"],
  "AI": ["h23", "h12"],
  "AL": ["h12", "h23"],
  "AM": ["h23"],
  "AO": ["h23"],
  "AR": ["h23", "h12"],
  "AS": ["h12", "h23"],
  "AT": ["h23"],
  "AU": ["h12", "h23"],
  "AW": ["h23"],
  "AX": ["h23"],
  "AZ": ["h23", "h12"],
  "BA": ["h23", "h12"],
  "BB": ["h12", "h23"],
  "BD": ["h12", "h23"],
  "BE": ["h23"],
  "BF": ["h23"],
  "BG": ["h23", "h12"],
  "BH": ["h12", "h23"],
  "BI": ["h23", "h12"],
  "BJ": ["h23"],
  "BL": ["h23"],
  "BM": ["h12", "h23"],
  "BN": ["h12", "h23"],
  "BO": ["h23", "h12"],
  "BQ": ["h23"],
  "BR": ["h23"],
  "BS": ["h12", "h23"],
  "BT": ["h12", "h23"],
  "BW": ["h23", "h12"],
  "BY": ["h23", "h12"],
  "BZ": ["h23", "h12"],
  "CA": ["h12", "h23"],
  "CC": ["h23", "h12"],
  "CD": ["h23"],
  "CF": ["h23", "h12"],
  "CG": ["h23"],
  "CH": ["h23", "h12"],
  "CI": ["h23"],
  "CK": ["h23", "h12"],
  "CL": ["h23", "h12"],
  "CM": ["h23", "h12"],
  "CN": ["h23", "h12"],
  "CO": ["h12", "h23"],
  "CP": ["h23"],
  "CR": ["h23", "h12"],
  "CU": ["h23", "h12"],
  "CV": ["h23"],
  "CW": ["h23"],
  "CX": ["h23", "h12"],
  "CY": ["h12", "h23"],
  "CZ": ["h23"],
  "DE": ["h23"],
  "DG": ["h23", "h12"],
  "DJ": ["h12", "h23"],
  "DK": ["h23"],
  "DM": ["h12", "h23"],
  "DO": ["h12", "h23"],
  "DZ": ["h12", "h23"],
  "EA": ["h23", "h12"],
  "EC": ["h23", "h12"],
  "EE": ["h23"],
  "EG": ["h12", "h23"],
  "EH": ["h12", "h23"],
  "ER": ["h12", "h23"],
  "ES": ["h23", "h12"],
  "ET": ["h12", "h23"],
  "FI": ["h23"],
  "FJ": ["h12", "h23"],
  "FK": ["h23", "h12"],
  "FM": ["h12", "h23"],
  "FO": ["h23", "h12"],
  "FR": ["h23"],
  "GA": ["h23"],
  "GB": ["h23", "h12"],
  "GD": ["h12", "h23"],
  "GE": ["h23", "h12"],
  "GF": ["h23"],
  "GG": ["h23", "h12"],
  "GH": ["h12", "h23"],
  "GI": ["h23", "h12"],
  "GL": ["h23", "h12"],
  "GM": ["h12", "h23"],
  "GN": ["h23"],
  "GP": ["h23"],
  "GQ": ["h23", "h12"],
  "GR": ["h12", "h23"],
  "GT": ["h23", "h12"],
  "GU": ["h12", "h23"],
  "GW": ["h23"],
  "GY": ["h12", "h23"],
  "HK": ["h12", "h23"],
  "HN": ["h23", "h12"],
  "HR": ["h23"],
  "HU": ["h23", "h12"],
  "IC": ["h23", "h12"],
  "ID": ["h23"],
  "IE": ["h23", "h12"],
  "IL": ["h23"],
  "IM": ["h23", "h12"],
  "IN": ["h12", "h23"],
  "IO": ["h23", "h12"],
  "IQ": ["h12", "h23"],
  "IR": ["h23"],
  "IS": ["h23"],
  "IT": ["h23"],
  "JE": ["h23", "h12"],
  "JM": ["h12", "h23"],
  "JO": ["h12", "h23"],
  "JP": ["h23", "h11", "h12"],
  "KE": ["h23", "h12"],
  "KG": ["h23", "h12"],
  "KH": ["h12", "h23"],
  "KI": ["h12", "h23"],
  "KM": ["h23", "h12"],
  "KN": ["h12", "h23"],
  "KP": ["h12", "h23"],
  "KR": ["h12", "h23"],
  "KW": ["h12", "h23"],
  "KY": ["h12", "h23"],
  "KZ": ["h23"],
  "LA": ["h23", "h12"],
  "LB": ["h12", "h23"],
  "LC": ["h12", "h23"],
  "LI": ["h23", "h12"],
  "LK": ["h23", "h12"],
  "LR": ["h12", "h23"],
  "LS": ["h12", "h23"],
  "LT": ["h23", "h12"],
  "LU": ["h23", "h12"],
  "LV": ["h23", "h12"],
  "LY": ["h12", "h23"],
  "MA": ["h23", "h12"],
  "MC": ["h23"],
  "MD": ["h23"],
  "ME": ["h23", "h12"],
  "MF": ["h23"],
  "MG": ["h23", "h12"],
  "MH": ["h12", "h23"],
  "MK": ["h23", "h12"],
  "ML": ["h23"],
  "MM": ["h23", "h12"],
  "MN": ["h23", "h12"],
  "MO": ["h12", "h23"],
  "MP": ["h12", "h23"],
  "MQ": ["h23"],
  "MR": ["h12", "h23"],
  "MS": ["h23", "h12"],
  "MT": ["h23", "h12"],
  "MU": ["h23", "h12"],
  "MV": ["h23", "h12"],
  "MW": ["h12", "h23"],
  "MX": ["h23", "h12"],
  "MY": ["h12", "h23"],
  "MZ": ["h23"],
  "NA": ["h12", "h23"],
  "NC": ["h23"],
  "NE": ["h23"],
  "NF": ["h23", "h12"],
  "NG": ["h23", "h12"],
  "NI": ["h23", "h12"],
  "NL": ["h23"],
  "NO": ["h23", "h12"],
  "NP": ["h23", "h12"],
  "NR": ["h23", "h12"],
  "NU": ["h23", "h12"],
  "NZ": ["h12", "h23"],
  "OM": ["h12", "h23"],
  "PA": ["h12", "h23"],
  "PE": ["h23", "h12"],
  "PF": ["h23", "h12"],
  "PG": ["h12", "h23"],
  "PH": ["h12", "h23"],
  "PK": ["h12", "h23"],
  "PL": ["h23", "h12"],
  "PM": ["h23"],
  "PN": ["h23", "h12"],
  "PR": ["h12", "h23"],
  "PS": ["h12", "h23"],
  "PT": ["h23"],
  "PW": ["h12", "h23"],
  "PY": ["h23", "h12"],
  "QA": ["h12", "h23"],
  "RE": ["h23"],
  "RO": ["h23"],
  "RS": ["h23", "h12"],
  "RU": ["h23"],
  "RW": ["h23", "h12"],
  "SA": ["h12", "h23"],
  "SB": ["h12", "h23"],
  "SC": ["h23", "h12"],
  "SD": ["h12", "h23"],
  "SE": ["h23"],
  "SG": ["h12", "h23"],
  "SH": ["h23", "h12"],
  "SI": ["h23"],
  "SJ": ["h23"],
  "SK": ["h23"],
  "SL": ["h12", "h23"],
  "SM": ["h23", "h12"],
  "SN": ["h23", "h12"],
  "SO": ["h12", "h23"],
  "SR": ["h23"],
  "SS": ["h12", "h23"],
  "ST": ["h23"],
  "SV": ["h23", "h12"],
  "SX": ["h23", "h12"],
  "SY": ["h12", "h23"],
  "SZ": ["h12", "h23"],
  "TA": ["h23", "h12"],
  "TC": ["h12", "h23"],
  "TD": ["h12", "h23"],
  "TF": ["h23", "h12"],
  "TG": ["h23"],
  "TH": ["h23", "h12"],
  "TJ": ["h23", "h12"],
  "TL": ["h23", "h12"],
  "TM": ["h23", "h12"],
  "TN": ["h12", "h23"],
  "TO": ["h12", "h23"],
  "TR": ["h23"],
  "TT": ["h12", "h23"],
  "TW": ["h12", "h23"],
  "TZ": ["h23", "h12"],
  "UA": ["h23", "h12"],
  "UG": ["h23", "h12"],
  "UM": ["h12", "h23"],
  "US": ["h12", "h23"],
  "UY": ["h23", "h12"],
  "UZ": ["h23", "h12"],
  "VA": ["h23", "h12"],
  "VC": ["h12", "h23"],
  "VE": ["h12", "h23"],
  "VG": ["h12", "h23"],
  "VI": ["h12", "h23"],
  "VN": ["h23", "h12"],
  "VU": ["h12", "h23"],
  "WF": ["h23"],
  "WS": ["h12", "h23"],
  "XK": ["h23", "h12"],
  "YE": ["h12", "h23"],
  "YT": ["h23"],
  "ZA": ["h23", "h12"],
  "ZM": ["h12", "h23"],
  "ZW": ["h23", "h12"],
  "af-ZA": ["h23", "h12"],
  "ar-001": ["h12", "h23"],
  "ca-ES": ["h23", "h12"],
  "en-001": ["h12", "h23"],
  "es-BO": ["h23", "h12"],
  "es-BR": ["h23", "h12"],
  "es-EC": ["h23", "h12"],
  "es-ES": ["h23", "h12"],
  "es-GQ": ["h23", "h12"],
  "es-PE": ["h23", "h12"],
  "fr-CA": ["h23", "h12"],
  "gl-ES": ["h23", "h12"],
  "gu-IN": ["h12", "h23"],
  "hi-IN": ["h12", "h23"],
  "it-CH": ["h23", "h12"],
  "it-IT": ["h23", "h12"],
  "kn-IN": ["h12", "h23"],
  "ml-IN": ["h12", "h23"],
  "mr-IN": ["h12", "h23"],
  "pa-IN": ["h12", "h23"],
  "ta-IN": ["h12", "h23"],
  "te-IN": ["h12", "h23"],
  "zu-ZA": ["h23", "h12"]
};